export class CostReviewElectricalProvidedDocuments {
  bookingPackageSigned!: number;
  scopeOfWorkReviewedAndValidated!: number;
}
